// @ts-check
import Edit from './Edit';

export default Edit;
